import { datadogLogs } from '@datadog/browser-logs'

import type { Logger } from '@/lib/logger'

export type LogAttributes = {
  browserWidth: number
  personId: string
  filterTab: string
  searchFilters: unknown
  trackingName: string
  subjectId: string
  customerId: string
  applicationId: string
  fileName: string
  error: unknown
  duration: number
  operationName: string
  query: {}
  status: number
  errors: unknown
  idCheckSelection: string
  verificationPresentBefore: boolean
  previousIdCheckStatus: string
  hasIdentityChecks: boolean
  hasR2RChecks: boolean
  validationReasons: string[]
  errorName: string
  errorKind: string
}

export type VouchLogger = Logger<LogAttributes>

const createLogger = (): VouchLogger => {
  datadogLogs.init({
    clientToken: 'pub8959c0e0c2daf06529f3e0e77ecd329b',
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    env: import.meta.env.MODE,
    service: 'Referencing Dashboard (FE)',
  })

  const debug = (name: string, attributes: Partial<LogAttributes> = {}) => {
    datadogLogs.logger.debug(name, attributes)
    console.debug(name, attributes)
  }

  const info = (name: string, attributes: Partial<LogAttributes> = {}) => {
    datadogLogs.logger.info(name, attributes)
    console.info(name, attributes)
  }

  const warning = (name: string, attributes: Partial<LogAttributes> = {}) => {
    datadogLogs.logger.warn(name, attributes)
    console.warn(name, attributes)
  }

  const error = (name: string, attributes: Partial<LogAttributes> = {}) => {
    datadogLogs.logger.error(name, attributes)
    console.error(name, attributes)
  }

  return {
    debug,
    info,
    warning,
    error,
  }
}

const vouchLogger = createLogger()

export default vouchLogger
